// extracted by mini-css-extract-plugin
module.exports = {"versionTime":"VersionFooter7df9be9d2ad5a4a5901c9136b86d05d3"};